export default __webpack_public_path__ + "static/media/logo.3c5a8544.svg";